"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisabledProgressBar = exports.ProgressBar = void 0;
var react_1 = __importDefault(require("react"));
var Flex_1 = require("../Flex");
var View_1 = require("../View");
var theme_1 = require("../theme");
var ProgressBar = function (_a) {
    var progress = _a.progress, height = _a.height, width = _a.width, color = _a.color, backgroundColor = _a.backgroundColor;
    // clamp progress to 0-100
    var percent = Math.min(Math.max(progress, 0), 100);
    var progressView = {
        height: '100%',
        width: "".concat(percent, "%"),
        backgroundColor: color // note: this is actually the color of the filled portion
            ? "".concat(theme_1.theme.colors[color])
            : "".concat(theme_1.theme.colors.blue800),
        borderTopLeftRadius: 40,
        borderBottomLeftRadius: 40,
    };
    var bgColor = backgroundColor ? "".concat(theme_1.theme.colors[backgroundColor]) : 'n60';
    if (percent === 100) {
        Object.assign(progressView, { borderTopRightRadius: 40 });
        Object.assign(progressView, { borderBottomRightRadius: 40 });
    }
    return (react_1.default.createElement(Flex_1.Flex, { height: height, width: width, backgroundColor: bgColor, margin: "space4", borderRadius: "circle" },
        react_1.default.createElement(View_1.View, { style: progressView, "data-testid": "progress-bar" })));
};
exports.ProgressBar = ProgressBar;
var DisabledProgressBar = function (_a) {
    var height = _a.height, width = _a.width, color = _a.color;
    var progressView = {
        height: '100%',
        width: "100%",
        backgroundColor: color ? "".concat(theme_1.theme.colors[color]) : "".concat(theme_1.theme.colors.n400),
        borderTopLeftRadius: 40,
        borderBottomLeftRadius: 40,
        borderTopRightRadius: 40,
        borderBottomRightRadius: 40,
    };
    return (react_1.default.createElement(Flex_1.Flex, { height: height, width: width, backgroundColor: "n60", margin: "space4", borderRadius: "circle" },
        react_1.default.createElement(View_1.View, { style: progressView, "data-testid": "progress-bar" })));
};
exports.DisabledProgressBar = DisabledProgressBar;
//# sourceMappingURL=index.js.map